/**
 * AI 应用中心模块配置 — 聚合入口
 *
 * 新增模块规则：
 * 1. 在 modules/ 下创建 {模块名}.ts，导出 {模块名}Module 常量
 * 2. 在下方按需添加到 AI_TOOL_MODULES 或 AI_APP_CENTER_MODULES 数组
 * 3. 不要修改其他模块的文件！
 */

export type { AiAppCenterModule } from './types'

// ========== AI 工具模块（独立入口） ==========
export { aiModelModule } from './modules/ai-model'
export { geoAgentModule } from './modules/geo-agent'
export { aiSecretaryModule } from './modules/ai-secretary'

import { aiModelModule } from './modules/ai-model'
import { geoAgentModule } from './modules/geo-agent'
import { aiSecretaryModule } from './modules/ai-secretary'

// ========== 业务模块 ==========
export { businessModule } from './modules/business'
export { digitalCardModule } from './modules/digital-card'
export { loveModule } from './modules/love'
export { mallModule } from './modules/mall'
export { rentalModule } from './modules/rental'
export { supplierModule } from './modules/supplier'
export { cateringModule } from './modules/catering'
export { daikeModule } from './modules/daike'
export { o2oModule } from './modules/o2o'
export { capacityModule } from './modules/capacity'
export { courseModule } from './modules/course'
export { hotelModule } from './modules/hotel'
export { lawyerModule } from './modules/lawyer'
export { lawyerFirmModule } from './modules/lawyer-firm'
export { scenicModule } from './modules/scenic'
export { ticketingModule } from './modules/ticketing'
export { aiEducationModule } from './modules/ai-education'
export { travelModule } from './modules/travel'
export { visitingModule } from './modules/visiting'
export { distributionModule } from './modules/distribution'
export { cmsModule } from './modules/cms'
export { eventModule } from './modules/event'
export { finModule } from './modules/fin'
export { microSceneModule } from './modules/micro-scene'
export { activityModule } from './modules/activity'
export { questionnaireModule } from './modules/questionnaire'
export { liveModule } from './modules/live'
export { shortvideoModule } from './modules/shortvideo'
export { propertyModule } from './modules/property'
export { promotionModule } from './modules/promotion'
export { carModule } from './modules/car'
export { tmsModule } from './modules/tms'
export { houseModule } from './modules/house'
export { errandModule } from './modules/errand'
export { xuanxueModule } from './modules/xuanxue'
export { spaceBookingModule } from './modules/space-booking'
export { xuanjiModule } from './modules/xuanji'

import { businessModule } from './modules/business'
import { digitalCardModule } from './modules/digital-card'
import { loveModule } from './modules/love'
import { mallModule } from './modules/mall'
import { rentalModule } from './modules/rental'
import { supplierModule } from './modules/supplier'
import { cateringModule } from './modules/catering'
import { daikeModule } from './modules/daike'
import { o2oModule } from './modules/o2o'
import { capacityModule } from './modules/capacity'
import { courseModule } from './modules/course'
import { hotelModule } from './modules/hotel'
import { lawyerModule } from './modules/lawyer'
import { lawyerFirmModule } from './modules/lawyer-firm'
import { scenicModule } from './modules/scenic'
import { ticketingModule } from './modules/ticketing'
import { aiEducationModule } from './modules/ai-education'
import { travelModule } from './modules/travel'
import { visitingModule } from './modules/visiting'
import { distributionModule } from './modules/distribution'
import { cmsModule } from './modules/cms'
import { eventModule } from './modules/event'
import { finModule } from './modules/fin'
import { microSceneModule } from './modules/micro-scene'
import { activityModule } from './modules/activity'
import { questionnaireModule } from './modules/questionnaire'
import { liveModule } from './modules/live'
import { shortvideoModule } from './modules/shortvideo'
import { propertyModule } from './modules/property'
import { promotionModule } from './modules/promotion'
import { carModule } from './modules/car'
import { tmsModule } from './modules/tms'
import { houseModule } from './modules/house'
import { errandModule } from './modules/errand'
import { xuanxueModule } from './modules/xuanxue'
import { spaceBookingModule } from './modules/space-booking'
import { xuanjiModule } from './modules/xuanji'
import type { AiAppCenterModule } from './types'

export const AI_TOOL_MODULES: AiAppCenterModule[] = [
  aiModelModule,
  geoAgentModule
]

export const AI_APP_CENTER_MODULES: AiAppCenterModule[] = [
  ...AI_TOOL_MODULES,
  aiSecretaryModule,
  businessModule,
  digitalCardModule,
  loveModule,
  mallModule,
  rentalModule,
  supplierModule,
  cateringModule,
  daikeModule,
  o2oModule,
  capacityModule,
  courseModule,
  hotelModule,
  lawyerModule,
  lawyerFirmModule,
  scenicModule,
  ticketingModule,
  aiEducationModule,
  travelModule,
  visitingModule,
  distributionModule,
  cmsModule,
  eventModule,
  finModule,
  microSceneModule,
  activityModule,
  questionnaireModule,
  liveModule,
  shortvideoModule,
  propertyModule,
  promotionModule,
  carModule,
  tmsModule,
  houseModule,
  errandModule,
  xuanxueModule,
  spaceBookingModule,
  xuanjiModule
]

export const AI_APP_CENTER_MENU_TITLES = AI_APP_CENTER_MODULES.flatMap((item) => [
  item.label,
  ...(item.aliases || [])
])

/** 库表若仍启用也不进 AI 应用中心（律师办公在 H5/App） */
export const AI_APP_CENTER_HIDDEN_MODULE_KEYS = ['lawyer-workbench'] as const
